import React from 'react';
import { useNavigate } from 'react-router-dom';
import './error-pages.scss';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__brand">RealityCoach</div>

        <div className="error-page__code error-page__code--blue">404</div>

        <h1 className="error-page__title">Page Not Found</h1>

        <p className="error-page__description">
          The page you're looking for doesn't exist or may have been moved.
          Please check the URL or return to the dashboard.
        </p>

        <div className="error-page__actions">
          <button className="error-page__btn-primary" onClick={() => navigate('/')}>
            Go to Dashboard
          </button>
          <button className="error-page__btn-secondary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>

        <p className="error-page__footer">Error code: 404 - Not Found</p>
      </div>
    </div>
  );
};

export default NotFoundPage;
